import { VIDEO_TOOL_LABELS } from "./constants"

export const ROUTER = {
  HOME: "/",
  TEMPLATE_DETAIL: "/template/:templateId",
  TEMPLATE_FAVORITES: "/template-favorites",
  ANALYSIS: "/analysis",
  VIDEO_SUBTITLE_ERASURE: "/video-subtitle-erasure",
  VIDEO_ENHANCEMENT: "/video-enhancement",
  ONE_CLICK_COPY: "/one-click-copy",
  ORDERS: "/orders",
  RECREATE: "/recreate",
  RECREATE_TASK: "/recreate/:taskId",
  RECREATE_V2: "/recreate-v2",
  RECREATE_V2_TASK: "/recreate-v2/:taskId",
  STAFF: "/staff",
  STAFF_RECREATE: "/staff/recreate",
  STAFF_ORDER: "/staff/order",
  STAFF_ORDER_LIST: "/staff/orders",
  STAFF_GIFT: "/staff/gift",
  STAFF_DOUDIAN_GIFT: "/staff/doudian-gift",
  STAFF_DOUDIAN_ORDER_LIST: "/staff/doudian-orders",
  STAFF_LAB: "/staff/lab",
  STAFF_ORDER_CLEANUP: "/staff/order-cleanup",
  STAFF_ORDER_CLEANUP_HISTORY: "/staff/order-cleanup-history",
  STAFF_ORDER_REFUND: "/staff/order-refunds",
  STAFF_VIDEO_COVER: "/staff/video-cover",
  STAFF_VIDEO_TEMPLATES: "/staff/video-templates",
  STAFF_USER_LIST: "/staff/users",
  STAFF_USER_VIDEO_LIST: "/staff/user-videos",
  STAFF_FRAME_COPY_TASK_LIST: "/staff/frame-copy-tasks",
  STAFF_ERASE_VIDEO_SUBTITLE_TASK_LIST: "/staff/erase-video-subtitle-tasks",
  STAFF_ENHANCE_VIDEO_TASK_LIST: "/staff/enhance-video-tasks",
  TASKS: "/tasks",
  XQT_CALLBACK: "/xqt_cb",
  DOUDIAN_CALL_BACK: "/doudian_cb",
  DOUYIN_CALL_BACK: "/douyin_cb",
} as const

export const getSafeRedirectPath = (redirect?: string | null) => {
  const value = redirect?.trim()

  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return ROUTER.HOME
  }

  try {
    const url = new URL(value, window.location.origin)

    if (url.pathname === ROUTER.XQT_CALLBACK) {
      return ROUTER.HOME
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return ROUTER.HOME
  }
}

export const getRecreateTaskPath = (taskId: string) => {
  return `${ROUTER.RECREATE}/${encodeURIComponent(taskId)}`
}

export const getStaffRecreatePath = (fusionId: string) =>
  `${ROUTER.STAFF_RECREATE}?${new URLSearchParams({ fusionId })}`

export const getStaffVideoTaskPath = (taskId: string) =>
  `${ROUTER.STAFF_USER_VIDEO_LIST}?${new URLSearchParams({ taskId, status: "2" })}`

export const getRecreateV2TaskPath = (taskId: string) => {
  return `${ROUTER.RECREATE_V2}/${encodeURIComponent(taskId)}`
}

export const ROUTE_META: Record<string, { path: string; label: string }> = {
  home: {
    path: ROUTER.HOME,
    label: "首页",
  },
  oneClickCopy: {
    path: ROUTER.ONE_CLICK_COPY,
    label: VIDEO_TOOL_LABELS.oneClickCopy,
  },
  recreate: {
    path: ROUTER.RECREATE,
    label: VIDEO_TOOL_LABELS.recreate,
  },
  recreateV2: {
    path: ROUTER.RECREATE_V2,
    label: VIDEO_TOOL_LABELS.frameCopy,
  },
  analysis: {
    path: ROUTER.ANALYSIS,
    label: "视频脚本拆解",
  },
  videoSubtitleErasure: {
    path: ROUTER.VIDEO_SUBTITLE_ERASURE,
    label: "视频去字幕",
  },
  videoEnhancement: {
    path: ROUTER.VIDEO_ENHANCEMENT,
    label: "视频画质提升",
  },
  tasks: {
    path: ROUTER.TASKS,
    label: "任务列表",
  },
} as const

export const getTemplateDetailPath = (templateId: string) =>
  ROUTER.TEMPLATE_DETAIL.replace(":templateId", encodeURIComponent(templateId))

export const getTemplateShareUrl = (templateId: string) =>
  new URL(getTemplateDetailPath(templateId), window.location.origin).href

export const getTemplateRetryPath = (templateId: string, token: string) =>
  `${getTemplateDetailPath(templateId)}?retry=${encodeURIComponent(token)}`

export type TaskListTabKey =
  | "frameCopy"
  | "origin"
  | "oneClickCopy"
  | "recreate"

export const TASK_LIST_TAB_PARAM = "tab"

export const getTaskListPath = (tab: TaskListTabKey) =>
  `${ROUTER.TASKS}?${TASK_LIST_TAB_PARAM}=${tab}`
